import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CamelCasePipe } from './camel-case/camel-case.pipe';
import { KabobCasePipe } from './kabob-case/kabob-case.pipe';

import { PhonePipe } from './phone/phone.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
import { SafeResourceUrlPipe } from './safe-resource-url/safe-resource-url.pipe';
import { SafeUrlPipe } from './safe-url/safe-url.pipe';

@NgModule({
    imports: [CommonModule, PhonePipe, SafeHtmlPipe, SafeResourceUrlPipe, SafeUrlPipe, KabobCasePipe, CamelCasePipe],
    providers: [PhonePipe, SafeHtmlPipe, SafeResourceUrlPipe, SafeUrlPipe, KabobCasePipe, CamelCasePipe],
    exports: [PhonePipe, SafeHtmlPipe, SafeResourceUrlPipe, SafeUrlPipe, KabobCasePipe, CamelCasePipe]
})
export class UzurvPipesModule {}
